// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1vdOo","buttons":"SendReceipts_buttons__2XnKY","email":"SendReceipts_email__2yH3i","bookApptTitle":"SendReceipts_bookApptTitle__2D349"};